module.exports = __webpack_public_path__ + "static/vwlogo2-636f35d6c8af5b7fe10c01d96e325942.png";